var render = function render(){var _vm=this,_c=_vm._self._c;return _c('authenticationDetails',{attrs:{"title":_vm.$t('pages.authenticationDetails.registerTitle'),"description":_vm.$t('pages.authenticationDetails.registerDescription'),"details":_vm.registerDetails,"title-text-color":"green","button-route":"login"}})
}
var staticRenderFns = []

export { render, staticRenderFns }